<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-3">
                <div class="card">
                    <div class="card-header">
                        Obrót użytkownika (wszystkie punkty)
                    </div>
                    <div class="card-body">
                        <div class="form-group">
                            <h3>{{ userAllStores.result}}</h3>
                        </div>
                        <div class="form-group">
                            <label for="sdsa">Użytkownik</label>
                            <select class="form-control form-control-sm" v-model="userAllStores.selectedUser">
                                <option v-for="user in userAllStores.users" :key="user.id" v-bind:value="user.login">
                                    {{user.surname}} {{ user.name }} 
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="exampleInputEmail1">Od</label>
                            <datepicker 
                                v-model="userAllStores.startDate"
                                :language="lang"
                            ></datepicker>
                        </div>
                        <div class="form-group">
                            <vue-timepicker 
                                :format="'HH:mm:ss'"
                                v-model="userAllStores.startTime"
                            ></vue-timepicker>
                        </div>
                        <div class="form-group">
                            <label for="exampleInputEmail1">Do</label>
                            <datepicker 
                            v-model="userAllStores.stopDate"
                            :language="lang"
                            ></datepicker>
                        </div>
                        <div class="form-group">
                            <vue-timepicker 
                                :format="'HH:mm:ss'"
                                v-model="userAllStores.stopTime"
                                ></vue-timepicker>
                        </div>
                        <button class="btn btn-primary" @click="userAllStoresDo">Oblicz</button>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="card">
                    <div class="card-header">
                        Obrót wszystkie punkty
                    </div>
                    <div class="card-body">
                        <div class="form-group">
                            <h3>{{ allStores.result}}</h3>
                        </div>
                        <div class="form-group">
                            <label for="exampleInputEmail1">Od</label>
                            <datepicker 
                                v-model="allStores.startDate"
                                :language="lang"
                            ></datepicker>
                        </div>
                        <div class="form-group">
                            <vue-timepicker 
                                :format="'HH:mm:ss'"
                                v-model="allStores.startTime"
                            ></vue-timepicker>
                        </div>
                        <div class="form-group">
                            <label for="exampleInputEmail1">Do</label>
                            <datepicker 
                            v-model="allStores.stopDate"
                            :language="lang"
                            ></datepicker>
                        </div>
                        <div class="form-group">
                            <vue-timepicker 
                                :format="'HH:mm:ss'"
                                v-model="allStores.stopTime"
                                ></vue-timepicker>
                        </div>
                        <button class="btn btn-primary" @click="allStoresDo">Oblicz</button>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="card">
                    <div class="card-header">
                        Obrót wybrany punkt
                    </div>
                    <div class="card-body">
                        <div class="form-group">
                            <h3>{{ store.result}}</h3>
                        </div>
                        <div class="form-group">
                            <label for="sdsa">Punkt</label>
                            <select class="form-control form-control-sm" v-model="store.selectedStore">
                                <option v-for="store in store.stores" :key="store.id" v-bind:value="store.id">
                                    {{store.name}}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="exampleInputEmail1">Od</label>
                            <datepicker 
                                v-model="store.startDate"
                                :language="lang"
                            ></datepicker>
                        </div>
                        <div class="form-group">
                            <vue-timepicker 
                                :format="'HH:mm:ss'"
                                v-model="store.startTime"
                            ></vue-timepicker>
                        </div>
                        <div class="form-group">
                            <label for="exampleInputEmail1">Do</label>
                            <datepicker 
                            v-model="store.stopDate"
                            :language="lang"
                            ></datepicker>
                        </div>
                        <div class="form-group">
                            <vue-timepicker 
                                :format="'HH:mm:ss'"
                                v-model="store.stopTime"
                                ></vue-timepicker>
                        </div>
                        <button class="btn btn-primary" @click="storeDo">Oblicz</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        Dziennik użytkownika
                    </div>
                    <div class="card-body">
                        <div class="form-group">
                            <label for="sdsa">Użytkownik</label>
                            <select class="form-control form-control-sm" v-model="userDetails.selectedUser">
                                <option v-for="user in userDetails.users" :key="user.id" v-bind:value="user.login">
                                    {{user.surname}} {{ user.name }} 
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="sdsa">Punkt</label>
                            <select class="form-control form-control-sm" v-model="userDetails.selectedStore">
                                <option v-for="store in userDetails.stores" :key="store.id" v-bind:value="store.id">
                                    {{store.name}}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="exampleInputEmail1">Od</label>
                            <datepicker 
                                v-model="userDetails.startDate"
                                :language="lang"
                            ></datepicker>
                        </div>
                        <div class="form-group">
                            <vue-timepicker 
                                :format="'HH:mm:ss'"
                                v-model="userDetails.startTime"
                            ></vue-timepicker>
                        </div>
                        <div class="form-group">
                            <label for="exampleInputEmail1">Do</label>
                            <datepicker 
                            v-model="userDetails.stopDate"
                            :language="lang"
                            ></datepicker>
                        </div>
                        <div class="form-group">
                            <vue-timepicker 
                                :format="'HH:mm:ss'"
                                v-model="userDetails.stopTime"
                                ></vue-timepicker>
                        </div>
                        <button class="btn btn-primary" @click="userDetailsDo">Oblicz</button>
                        
                        <table class="table table-sm table-striped mt-4">
                            <thead>
                                <tr>
                                    <th scope="col">
                                        Data
                                    </th>
                                    <th scope="col">
                                        Kategoria
                                    </th>
                                    <th scope="col">
                                        Model
                                    </th>
                                    <th scope="col">
                                        Kolor
                                    </th>
                                    <th scope="col">
                                        Produkt
                                    </th>
                                    <th scope="col">
                                        Cena
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in userDetails.items" :key="index">
                                    <td> {{ displayDate(item.eventDate) }} </td>
                                    <td> {{ item.productCategory}} </td>
                                    <td> {{ item.productBrand}} </td>
                                    <td> {{ item.productColor}} </td>
                                    <td> {{ item.productName}} </td>
                                    <td> {{ item.price}} zł </td>
                                </tr>
                            </tbody>
                        </table>
                        <dir>
                            <h5>
                                {{ userDetails.result }}
                            </h5>
                        </dir>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import alertify from 'alertifyjs';
import userService from '@/service/userService'
import axios from 'axios'
import appConfig from '@/service/config'
import un from 'underscore'
import moment from 'moment'
import datepicker from 'vuejs-datepicker';
import {pl} from 'vuejs-datepicker/dist/locale'
import VueTimepicker from 'vue2-timepicker'
import MainPresenter from "@/service/MainPresenter"

const mainPresenter = new MainPresenter();

export default {
    components: {
      datepicker,
      VueTimepicker  
    },
    data: () => ({
        pageable: appConfig.pageableMainParams,
        lang: pl,
        users: [],
        user: userService.getCurrentUser(),
        userAllStores: {
            result: "",
            selectedUser: "",
            users: [],
            startDate: "",
            startTime: {
                HH: "00",
                mm: "00",
                ss: "00"
            },
            stopDate: "",
            stopTime: {
                HH: "00",
                mm: "00",
                ss: "00"
            }
        },
        allStores: {
            result: "",
            users: [],
            startDate: "",
            startTime: {
                HH: "00",
                mm: "00",
                ss: "00"
            },
            stopDate: "",
            stopTime: {
                HH: "00",
                mm: "00",
                ss: "00"
            }
        },
        store: {
            result: "",
            selectedStore: "",
            stores: [],
            startDate: "",
            startTime: {
                HH: "00",
                mm: "00",
                ss: "00"
            },
            stopDate: "",
            stopTime: {
                HH: "00",
                mm: "00",
                ss: "00"
            }
        },
        userDetails: {
            items: [],
            result: "",
            selectedStore: "",
            selectedUser: "",
            stores: [],
            startDate: "",
            startTime: {
                HH: "00",
                mm: "00",
                ss: "00"
            },
            stopDate: "",
            stopTime: {
                HH: "00",
                mm: "00",
                ss: "00"
            }
        }
    }),
    mounted() {
        this.loadUsers()
        this.loadStores()
        let startDate = moment().subtract(1,'days').startOf('day').format("YYYY-MM-DD\THH:mm:ss")
        let endDate = moment().add(1,'days').startOf('day').format("YYYY-MM-DD\THH:mm:ss")
    },
    methods: {
        loadStores() {
            this.pageable.sort = "name,asc"
            const req = axios({
                method: 'get',
                url: mainPresenter.getUrlForCommonData("/stores?sort=name", {}, this.pageable),
                headers: {
                Authorization: userService.getAuthHeader()
                }
            })
            req.then(res => {
                this.store.stores = res.data._embedded.stores;
                this.userDetails.stores = res.data._embedded.stores;
            }).catch(_ => {
                console.log('blad categories')
            })
        },
        loadUsers() {
            const req = axios({
            method: 'get',
            url: appConfig.baseUrl + '/users',
            headers: {
                    Authorization: userService.getAuthHeader()
                }
            })
            req.then(res => {
                let users = un.map(res.data, item => {
                    return {
                    id: item.id,
                    login: item.login,
                    name: item.userInfo.userName,
                    surname: item.userInfo.userSurname,
                    store: item.store
                    }
                });
                users = un.sortBy(users, user => {
                    return user.surname.toLowerCase();
                });
                this.users = users;
                this.userAllStores.users = users
                this.userDetails.users = users
            }).catch(err => {
                console.log(err);
            })
        },
        formatDate(date, time) {
            return moment(date).format('YYYY-MM-DD') 
                + "T" + time.HH + ":" + time.mm + ":" + time.ss
        },
        displayDate(date) {
            return moment(date).format('HH:mm:ss YYYY-MM-DD') 
        },
        userAllStoresDo() {
            let start = this.formatDate(this.userAllStores.startDate, this.userAllStores.startTime)
            let stop = this.formatDate(this.userAllStores.stopDate, this.userAllStores.stopTime)
            this.updateUserAllStores(start, stop, this.userAllStores.selectedUser)
        },
        updateUserAllStores(start, stop, user) {
            let data = {
                "user": user,
                "timeSpan": {
                    "start": start,
                    "stop": stop
                }
            }
            const req = axios({
                method: 'post',
                url: appConfig.baseUrl + '/turnover/userAllStores',
                data: data,
                headers: {
                    Authorization: userService.getAuthHeader()
                }
            });
            req.then(res => {
                this.userAllStores.result = `Obrót: ${res.data.total} zł` 
            }).catch(err => {
                console.log(err);
            })
        },
        allStoresDo() {
            let start = this.formatDate(this.allStores.startDate, this.allStores.startTime)
            let stop = this.formatDate(this.allStores.stopDate, this.allStores.stopTime)
            this.updateAllStores(start, stop)
        },
        updateAllStores(start, stop) {
            let data = {
                "timeSpan": {
                    "start": start,
                    "stop": stop
                }
            }
            const req = axios({
                method: 'post',
                url: appConfig.baseUrl + '/turnover/allStores',
                data: data,
                headers: {
                    Authorization: userService.getAuthHeader()
                }
            });
            req.then(res => {
                this.allStores.result = `Obrót: ${res.data.total} zł` 
            }).catch(err => {
                console.log(err);
            })
        },
        storeDo() {
            let start = this.formatDate(this.store.startDate, this.store.startTime)
            let stop = this.formatDate(this.store.stopDate, this.store.stopTime)
            this.updateStore(start, stop, this.store.selectedStore)
        },
        updateStore(start, stop, storeId) {
            let data = {
                "storeId": storeId,
                "timeSpan": {
                    "start": start,
                    "stop": stop
                }
            }
            const req = axios({
                method: 'post',
                url: appConfig.baseUrl + '/turnover/store',
                data: data,
                headers: {
                    Authorization: userService.getAuthHeader()
                }
            });
            req.then(res => {
                this.store.result = `Obrót: ${res.data.total} zł` 
            }).catch(err => {
                console.log(err);
            })
        },
        userDetailsDo() {
            let start = this.formatDate(this.userDetails.startDate, this.userDetails.startTime)
            let stop = this.formatDate(this.userDetails.stopDate, this.userDetails.stopTime)
            this.updateUserDetails(start, stop, this.userDetails.selectedStore, this.userDetails.selectedUser)
        },
        updateUserDetails(start, stop, storeId, user) {
            let data = {
                "storeId": storeId,
                "user": user,
                "timeSpan": {
                    "start": start,
                    "stop": stop
                }
            }
            const req = axios({
                method: 'post',
                url: appConfig.baseUrl + '/turnover/userDetails',
                data: data,
                headers: {
                    Authorization: userService.getAuthHeader()
                }
            });
            req.then(res => {
                this.userDetails.items = res.data.items
                this.userDetails.result = `Suma ${res.data.totalTurnover}zł`
            }).catch(err => {
                console.log(err);
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/stats/Stats.vue